
export const environment = {
  production: false,

  tupApiKey: `geXGxGlXE45pOs1vGvgk23rgxBVh8NqN4wkzAAWe`,

  devportalApi: {
    url:`https://api.telmar.com/devportal/v2`,
    endpoints: {
      apis: "/apis",
    }
  },

  tupAuth: {
    loginLocation: '/login',
    defaultLocation: '/',
  },

  amplifyAuth: {
    region: "us-east-1",
    userPoolId: "us-east-1_oAyEC7JId",
    userPoolWebClientId: "1gcn08pu5vqo45bse464m793f4",
    //
    mandatorySignIn: true,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    cookieStorage: {
      // REQUIRED - Cookie domain (only required if cookieStorage is provided)
      domain: "telmar.com",
      expires: 365,
      secure: true
    },
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
